import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"
import { RiStockFill, RiStockLine } from "react-icons/ri"
import {
  MdOutlineSupportAgent,
  MdOutlineTipsAndUpdates,
  MdQuestionMark,
  MdReviews,
  MdUpload,
} from "react-icons/md"
import { PiSubtitles } from "react-icons/pi"
import { AiOutlineAudit, AiOutlineStock } from "react-icons/ai"
import { BsCashCoin } from "react-icons/bs"
import { Modal, notification } from "antd"
import { CloseOutlined } from "@ant-design/icons"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import secureLocalStorage from "react-secure-storage"
import ConfigUrl, { axiosbaseurl } from "../../config"
import { FaUser, FaUserLock, FaUserTie } from "react-icons/fa"
import { SiCoinmarketcap, SiTicktick } from "react-icons/si"
import { usePermissionData } from "AppContext"
import { IoMdWarning } from "react-icons/io"
import Loader from "pages/Loader"

const SidebarContent = props => {
  const { checkAccess } = usePermissionData()

  const ref = useRef()
  const fileInputRef = useRef(null)
  const [loading, setLoading] = useState(false)

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  const [TradeModal, setModal] = useState(false)
  const [portfolios, setportfolios] = useState()

  const handleUpload = async () => {
    if (!portfolios) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Please select a file to upload</div>
          </div>
        ),
      })

      return
    }
    if (
      portfolios.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      portfolios.type !== "application/vnd.ms-excel"
    ) {
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Only .xls & .xlsx files are allowed.</div>
          </div>
        ),
      })

      return
    }

    setModal(false)

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("sendEmailSheet", portfolios)

      const response = await axiosbaseurl.post(
        `customer-management/send/emails`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      if (response?.data?.success) {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">{response?.data?.message}</div>
            </div>
          ),
          placement: "topRight",
        })
      } else {
        setLoading(false)
        setportfolios()
        fileInputRef.current.value = ""
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      setLoading(false)
      setportfolios()
      fileInputRef.current.value = ""
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to={`${ConfigUrl.appurl}dashboard`} className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>
            </li>

            {checkAccess(11, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}daily-trades`}>
                  <i>
                    <AiOutlineStock />
                  </i>
                  <span>{props.t("Daily Trades")}</span>
                </Link>
              </li>
            )}

            <li>
              <Link to={`${ConfigUrl.appurl}market`}>
                <i>
                  <SiCoinmarketcap />
                </i>
                <span>{props.t("Live Market")}</span>
              </Link>
            </li>

            {checkAccess(3, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}customers`}>
                  <i>
                    <FaUser />
                  </i>
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>
            )}

            {checkAccess(1, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}portfolio`}>
                  <i>
                    <RiStockFill />
                  </i>
                  <span>{props.t("Portfolios")}</span>
                </Link>
              </li>
            )}

            {checkAccess(1, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}stock-purchase`}>
                  <i>
                    <RiStockFill />
                  </i>
                  <span>{props.t("Stock Purchase")}</span>
                </Link>
              </li>
            )}

            {checkAccess(1, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}trading`}>
                  <i>
                    <AiOutlineStock />
                  </i>
                  <span>{props.t("Trading")}</span>
                </Link>
              </li>
            )}

            {checkAccess(10, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}payouts`}>
                  <i>
                    <BsCashCoin />
                  </i>
                  <span>{props.t("Payouts")}</span>
                </Link>
              </li>
            )}

            {checkAccess(4, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}users`}>
                  <i>
                    <FaUserTie />
                  </i>
                  <span>{props.t("Staff Management")}</span>
                </Link>
              </li>
            )}

            {checkAccess(5, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}roles`}>
                  <i>
                    <FaUserLock />
                  </i>
                  <span>{props.t("Roles & Permissions")}</span>
                </Link>
              </li>
            )}

            {checkAccess(2, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}tips`}>
                  <i>
                    <MdOutlineTipsAndUpdates />
                  </i>
                  <span>{props.t("News and Update")}</span>
                </Link>
              </li>
            )}

            {checkAccess(12, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}customer-query`}>
                  <i>
                    <MdOutlineSupportAgent />
                  </i>
                  <span>{props.t("Customer Query")}</span>
                </Link>
              </li>
            )}

            {(checkAccess(6, 1) || checkAccess(8, 1) || checkAccess(9, 1)) && (
              <li>
                <a
                  className="has-arrow dropdown-menu1"
                  style={{ background: "transparent" }}
                >
                  <i className="fas fa-list"></i>
                  <span>{props.t("Website")}</span>
                </a>
                <ul className="sub-menu">
                  {checkAccess(6, 1) && (
                    <li>
                      <Link to={`${ConfigUrl.appurl}contact-enquiry`}>
                        <i>
                          <MdQuestionMark />
                        </i>
                        <span>{props.t("Contact Enquiry")}</span>
                      </Link>
                    </li>
                  )}

                  {checkAccess(8, 1) && (
                    <li>
                      <Link to={`${ConfigUrl.appurl}testimonials`}>
                        <i>
                          <MdReviews />
                        </i>
                        <span>{props.t("Testimonials")}</span>
                      </Link>
                    </li>
                  )}

                  {checkAccess(9, 1) && (
                    <li>
                      <Link to={`${ConfigUrl.appurl}meta-content`}>
                        <i>
                          <PiSubtitles />
                        </i>
                        <span>{props.t("Meta Titles")}</span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {checkAccess(7, 1) && (
              <li>
                <Link to={`${ConfigUrl.appurl}audit-logs`}>
                  <i>
                    <AiOutlineAudit />
                  </i>
                  <span>{props.t("Audit logs")}</span>
                </Link>
              </li>
            )}

            {/* <li>
            <Link  onClick={(e) => handleLogout(e)}>
              <i>
                <MdLogout />
              </i>
              <span>{props.t("Log Out")}</span>
            </Link>
          </li> */}
          </ul>
        </div>
      </SimpleBar>
      <Modal
        open={TradeModal}
        onCancel={() => setModal(false)}
        title=""
        footer={false}
        width={800}
        style={{ top: 50 }}
        closeIcon={<CloseOutlined style={{ color: "white", fontSize: 20 }} />}
      >
        <div className="Modal-Body mt-4">
          <div className="Card"></div>
          <div className="Card mt-2">
            <h5 className="fw-bold mb-0 py-3 ps-4">Daily Trade Upload</h5>
            <div className="Instruction">
              <div className="form-group">
                <label className="fw-bold fs-6">
                  Upload File <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  accept=".xlsx , .xls"
                  ref={fileInputRef}
                  className="form-control"
                  onChange={e => {
                    console.log(e)
                    setportfolios(e.target.files[0])
                  }}
                />
              </div>
              <div
                className="btn delete-Button mt-3 fs-6"
                onClick={() => handleUpload()}
              >
                <MdUpload /> Upload
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
